module.exports = function(){




    if ( $('[js-form-eph-contact-us]').length ) {
        $('[js-form-eph-contact-us]').parsley();
    }



    $('[js-form-eph-contact-us]').on('submit', function(event) {
        event.preventDefault();

        var $form = $(this),
            $formResponse = $('.js-form-response');

        if ( !$form.parsley().isValid() ) {
            return false;
        }


        $form.find('button[type="submit"]').text('Sending...');

        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            complete: function(data, responseText, xhr) {

                var data = JSON.parse( JSON.stringify(data) );
                var response = JSON.parse( data.responseText );

                if(response.type === 'success') {
                    $form.find('button[type="submit"]').text('Message sent successfully.');
                    $form.find($formResponse).text('Success! Your message has been received by our hard working service team who will respond to your inquiry within one business day.');
                    $form.find($formResponse).addClass('is-visible is-success');
                    $form.find('input, button, textarea').prop('disabled', true);
                }
                else {
                    // $form.find('button[type="submit"]').text('Drop Us a Line');
                }

            }

        });


    });




}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/form-contact-us.js